module.exports = __webpack_public_path__ + "img/Cleric.74771c47.png";